const $ = require('jquery');
import {setElementsFromScope, combineElements} from "../../utilities/selectorHelpers";
import {keyDefaultFalseOption} from '../../utilities/general';
import render from "../../utilities/render";
import ErrorModal from "../ErrorModal/ErrorModal";
// const modalHtml = require("./html/baseModal.html");
const modalHtml = require("../../sharedHtml/modal.html");
const modalAlertHtml = require("./html/alertModal.html");

require("./SubmitModalFlow.less");

const elementsMap = {
  closeBtn: ".top-close-btn",
  confirmBtn: ".confirm-btn"
};


//Expose SubmitModal globally for old code
window.SubmitModalFlow = SubmitModalFlow;

export default function SubmitModalFlow(options={}){
  const self = this;
  const els = {};
  let standardModal, loadingModal, successModal;

  const errorModal = new ErrorModal();
  errorModal.init();

  const showErrorModal = errorModal.showModal;
  const hideErrorModal = errorModal.hideModal;

  self.setErrors = errorModal.setErrors;

  self.init = function(){
    buildHtml();
    setElements();
    bindElements();
  };

  self.showConfirmModal = function(){
    showComfirmModal();
  };

  self.showLoadingModal = function(){
    hideAllModals();
    showLoadingModal();
  };

  self.showSuccessModal = function(){
    hideAllModals();
    showSuccessModal();
  };

  self.showFailureModal = function(){
    hideAllModals();
    showFailureModal();
  };

  self.hideAllModals = function(){
    hideAllModals();
  };
  
  self.getConfirmModalBody = function(){
	 return standardModal.find(".modal-body");
  };

  function buildHtml(){
    // Set Options
    const modalDefaults = {
      backdrop:'static',
      keyboard: false,
      show: false
    };

    // Build Modals
    standardModal = $(render(
      modalHtml,
      {
        title: options.confirmModalTitle || 'Confirm',
        subtitle: options.confirmModalSubtitle,
        leftAlignTitle: keyDefaultFalseOption(options, "confirmModalLeftAlignTitle"),
        body: options.confirmModalBody || 'Are you sure?',
        topCloseBtn: keyDefaultFalseOption(options, "confirmModalTopClose"),
        modalDialogClass: options.modalDialogClass || "",
        footerBtns: '<a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Cancel</a> <a href="#" class="base-btn purple-btn confirm-btn">' + (options.confirmModalBtnText || 'Confirm') + '</a>'
      }
    ));
    loadingModal = $(render(
      modalAlertHtml,
      {
        title: 'Submitting Request',
        body: '<div class="q-pad-all-xl"><div class="inline-dots-loader"></div></div>'
      }
    ));
    successModal = $(render(
      modalAlertHtml,
      {
        title: 'Success',
        body: '<div class="q-pad-all-xl"><i class="fa fa-check-circle-o q-fa-success fa-4x"></i></div>'
      }
    ));

    // Apply Options
    combineElements([standardModal, loadingModal, successModal]).modal(modalDefaults);
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, standardModal);
  }

  function bindElements(){
    els.confirmBtn.on('click', onConfirmClick);
    els.closeBtn.on('click', onConfirmCloseClick);
  }

  function showComfirmModal(){
    standardModal.modal("show");
  }

  function showLoadingModal(){
    loadingModal.modal("show");
  }

  function showSuccessModal(){
    successModal.modal("show");
  }

  function showFailureModal(){
    showErrorModal();
  }

  function hideConfirmModal(){
    standardModal.modal("hide");
  }

  function hideAllModals(){
    standardModal.modal("hide");
    loadingModal.modal("hide");
    successModal.modal("hide");
    hideErrorModal();
  }

  function onConfirmClick(e){
    e.preventDefault();
    options.onConfirmClick && options.onConfirmClick();
  }

  function onConfirmCloseClick(e){
    e.preventDefault();
    const shouldClose = options.shouldCloseModal && options.shouldCloseModal();
    if (shouldClose !== false) {
      hideConfirmModal();
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/SubmitModalFlow/SubmitModalFlow.js